<table>
  @if (match.datePlanned) {
    <tr>
      <td class="info-td">{{'DATE' | translate}}:</td>
      <td>
        {{match.datePlanned | matchDatePipe: 'full'}}
        @if (match.reschedule) {
          <span>&nbsp;({{'MATCH_RESCHEDULED' | translate}})</span>
        }
      </td>
    </tr>
  }
  @if (match.matchReport) {
    <tr>
      <!-- TODO Spielort -->
    </tr>
  }
  <tr>
    <td class="info-td">{{'HOME' | translate}}:</td>
    <td>
      {{match.participantHome | participantPipe: true: match: undefined: match.event}}
    </td>
  </tr>
  <tr>
    <td class="info-td">{{'GUEST' | translate}}:</td>
    <td>
      {{match.participantGuest | participantPipe: false: match: undefined: match.event}}
    </td>
  </tr>
  <tr>
    <td class="info-td">{{'RESULT' | translate}}:</td>
    <td>
      {{match | matchResultFullPipe}}
    </td>
  </tr>
  <tr>
    <td class="info-td">{{'STATUS' | translate}}:</td>
    <td>
      {{match.status?.value | translate}}
    </td>
  </tr>
  @if (!match.matchReport) {
    <tr>
      <td class="info-td">{{(isEDart ? 'MACHINE' : 'BOARD') | translate}}:</td>
      <td>
        {{match.board}}
      </td>
    </tr>
  }
  @if (!match.matchReport) {
    <tr>
      <td class="info-td">{{'WRITER' | translate}}:</td>
      <td>
        {{match.writer | participantPipe: undefined: undefined: undefined: undefined}}
      </td>
    </tr>
  }
  @if (!match.matchReport) {
    <tr>
      <td class="info-td">{{'MODE' | translate}}:</td>
      <td>
        {{match.matchmode | setlegmodePipe}}
      </td>
    </tr>
  }
  @if (match.duration > 0 && !match.matchReport) {
    <tr>
      <td class="info-td">{{'DURATION' | translate}}:</td>
      <td>
        {{match.duration | durationPipe}}
      </td>
    </tr>
  }
  @if (match.beginDate && !match.matchReport) {
    <tr>
      <td class="info-td">{{'MATCH_BEGIN' | translate}}:</td>
      <td>
        {{match.beginDate | matchDatePipe: 'full'}}
      </td>
    </tr>
  }
  @if (match.endDate && !match.matchReport) {
    <tr>
      <td class="info-td">{{'MATCH_END' | translate}}:</td>
      <td>
        {{match.endDate | matchDatePipe: 'full'}}
      </td>
    </tr>
  }
  @if (!match.matchReport) {
    <tr>
      <td class="info-td">{{'MATCH_NR_SINGLE' | translate}}:</td>
      <td>
        {{match.gameNr}}
      </td>
    </tr>
  }
  @if (!match.matchReport) {
    <tr>
      <td class="info-td">{{'MATCH_NR_ROUND' | translate}}:</td>
      <td>
        {{match.gameNrRound}}
      </td>
    </tr>
  }
  @if (match.referee) {
    <tr>
      <td class="info-td">{{'REFEREE' | translate}}:</td>
      <td>
        {{match.referee.lastname}}, {{match.referee.firstname}}
      </td>
    </tr>
  }
</table>
@if (match.playingVenue) {
  <div>
    <p-divider class="bg-gray" align="left">
      <div class="inline-flex align-items-center">
        <b>{{'PLAYING_VENUE' | translate}}</b>
      </div>
    </p-divider>
    <app-frontend-playingvenue-data [playingVenue]="match.playingVenue"/>
  </div>
}
@if (frontendLink) {
  <div class="pt-4">
    <p-button class="sm:mr-2 mt-1 xl:mt-0" icon="pi pi-clipboard" styleClass="p-button-sm p-button-text"
              [label]="'LINK_TO_MATCHPLAN' | translate"
              [cdkCopyToClipboard]="frontendLink"
              (onClick)="restErrorHelper.showInfoMessageService('COPIED_TO_CLIPBOARD', 2000)"
              [pTooltip]="'FRONTEND_LINK_MATCHPLAN' | translate" [showDelay]="400"/>
  </div>
}
